import { theme } from 'antd';
import { useNavigate } from 'react-router-dom';

const usePasswordReseted = () => {
  const { token } = theme.useToken();
  const navigate = useNavigate();

  const goLogin = () => {
    navigate('/login');
  };

  return {
    token,
    goLogin,
  };
};

export default usePasswordReseted;
